"use strict";

/**
 * Предоставляет инструменты для работы с обновлениями Агента веб-доступа.
 *
 * @namespace WebAccess.agent.updates
 * @since 5.0.0.4100 
 */
(function (global) {
  var updates = {

    /**
     * Проверить наличие обновлений для Агента веб-доступа.
     *
     * @method WebAccess.agent.updates.checkUpdates
     * @return {bool} True – Агента веб-доступа имеет одно или несколько обновлений, иначе False.
     */
    checkUpdates: function() {

      var d = $.Deferred();

      var params = {
        "IsSecured": (document.location.protocol === 'http:' ? 'n' : 'y'),
        "Host": document.location.host,
        "ClientAffinity": ($.cookie('ARRAffinity') == null ? '' : $.cookie('ARRAffinity'))
      };

      //Получаем токен на запрос уведомлений о новых заданиях
      WA.SRV.callSync("/Security.asmx/GetOpToken0", { Operation: TOKEN_OPERATION.UPDATE_AGENT }).done(function (res) {
          params["Token"] = res;        
      });

      global.transmitRequest("CheckUpdates", "", params).done(function(response) {
        if (response.result === "YES") {
          d.resolve();
        } else {
          d.reject();
        };
      }).fail(function(response) {
        d.reject();
      });
     
      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить информацию о прогрессе загрузки обновления Агента веб-доступа.
     * Рассчитывается в процентах.
     *
     * @method WebAccess.agent.updates.getUpdateProgress
     * @return {int} Процент загруженного обновления.
     */
    getUpdateProgress: function() {
      return global.transmitRequest("GetUpdateProgress", "", {});
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  };

  global.updates = updates;
})(window.WebAccess.agent);
